import { render, staticRenderFns } from "./setRole.vue?vue&type=template&id=0a173186&scoped=true&"
import script from "./setRole.vue?vue&type=script&lang=js&"
export * from "./setRole.vue?vue&type=script&lang=js&"
import style0 from "./setRole.vue?vue&type=style&index=0&id=0a173186&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a173186",
  null
  
)

export default component.exports